<vt-layout>
  <vt-toolbar (openHelp)="onOpenHelp()"></vt-toolbar>

  <app-loader *ngIf="showLoader | async" [coverHeader]="coverHeader | async"></app-loader>
  <router-outlet></router-outlet>

  <vt-footer></vt-footer>
</vt-layout>